@if (!navigatieVoorkeurService.nieuweNavigatie()) {
	<div class="menu">
		<app-user-tab-menu></app-user-tab-menu>
	</div>
}
<div class="content">
	<router-outlet></router-outlet>
</div>
